export enum AddressType {
  Shipping = "SHIPPING",
  Billing = "BILLING",
  Other = "OTHER",
}

export const mapToAddressTypeEnum = (type?: string): AddressType => {
  if (type === AddressType.Shipping) {
    return AddressType.Shipping;
  }
  if (type === AddressType.Billing) {
    return AddressType.Billing;
  }
  return AddressType.Other;
};
